import { axiosPrivate } from '../hooks/axiosPrivate';

const upload = (file,subproduct_id, onUploadProgress) => {
  let formData = new FormData();

  formData.append("avatar", file); 
  formData.append("subproductid", subproduct_id); 
console.log(formData);

  return axiosPrivate.post("/excursionsubproductimage/createsubproductsimages", formData, {
    headers: {
        "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });
};

const getFiles = () => {
  return axiosPrivate.get("/files");
};

const FileUploadApi2 = {
  upload,
  getFiles,
};

export default FileUploadApi2; 